<template>
  <div>
    <Header
      title="审核"
      type="0"
      :route="params.route1+'?list=' + JSON.stringify(params)"
    ></Header>
    <div class="stop-item">
      <div style="width:100%;">
        <van-cell-group>
          <van-field
            v-if="isShowShyj"
            v-model="shyj"
            label="上一步审核意见"
            type="textarea"
            autosize
            readonly
          />
          <van-field
            v-if="isShowFile"
            v-model="fj"
            type="textarea"
            autosize
            label="上一步审核附件"
            readonly
          />
          <van-field
            v-model="spjg"
            label="审批结果"
            placeholder="请点击选择"
            readonly
            is-link
            @click="showPicker1 = true"
            input-align="right"
          />
          <van-field
            v-model="shr.mc"
            v-if="shr_flag == '1'"
            label="下一步审核人"
            placeholder="请点击选择"
            readonly
            is-link
            @click="show1 = true"
            input-align="right"
          />
          <van-field
            class="xx"
            v-model="bz"
            label="备注"
            placeholder="非必填"
            input-align="right"
          />
        </van-cell-group>
      </div>
      <div v-if="isShowFile">
        <van-button class="bottom-button" type="default" @click="CheckFile"
          >查看附件</van-button
        >
        <van-button class="bottom-button1" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <div v-else>
        <van-button class="bottom-button2" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker
          show-toolbar
          :columns="isEndShow == '1' ? columns : columns1"
          @confirm="onConfirm1"
          :item-height="35"
          @cancel="showPicker1 = false"
        />
      </van-popup>
      <van-popup v-model="show1" position="bottom">
        <div class="apply-pop">
          <div class="pop-title">
            <i class="close-icon" @click="show1 = false"></i>
            <p>审核人</p>
            <i class="confirm-icon" @click="resetCancel()"></i>
          </div>
          <div class="person">
            <button
              class="per-btn"
              ref="person"
              v-for="(item, index) in shrList"
              @click="personTap($event, index)"
              :key="item.id"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import tApi from "../../../../utils/teacher";
export default {
  data() {
    return {
      // 备注
      bz: "审核通过",
      // 审批结果
      showPicker1: false,
      spjg: "通过",
      spjgId: "1",
      columns: [
        { text: "通过", value: "1" },
        { text: "不通过", value: "0" },
        { text: "终止流程", value: "2" }
      ],
      columns1: [{ text: "通过", value: "1" }, { text: "不通过", value: "0" }],
      // 业务id
      ywinstanceid: "",
      // 是否有附件
      isShowFile: false,
      isShowShyj: false,
      shyj: "",
      fj: "",
      img: {},
      shyjData: {},
      // 控制是否终止流程
      isEndShow: "",
      // 上个页面路由的参数
      params: {},
      // 控制下一步审核人是否显示
      shr_flag: "",
      // 审核人
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ]
    };
  },
  watch: {
    spjgId: {
      handler(n) {
        if (n == "1") {
          this.bz = "审核通过";
        }
        if (n == "0") {
          this.bz = "审核不通过";
        }
      },
      deep: true
    }
  },
  mounted() {
    this.params = JSON.parse(this.$route.query.list);
    this.getSybList();
    if (this.params.shlx != "2") {
      this.getList();
    }
  },
  methods: {
    CheckFile() {
      this.params.route = "/freePass/pass";
      localStorage.setItem("shyjData", JSON.stringify(this.shyjData));
      this.$router.push({
        path: "/teacher/filePreview",
        query: {
          list: JSON.stringify(this.params)
        }
      });
    },
    async getSybList() {
      const sh = await tApi.querySybShyj({
        id: this.params.shid
      });
      if (sh.data !== null) {
        this.shyj = sh.data.shyj;
        this.fj = sh.data.qzwffilename;
        this.shyjData = sh.data;

        if (!!this.fj) {
          this.isShowFile = true;
        }
        if (!!this.shyj) {
          this.isShowShyj = true;
        }
      }
    },
    async getList() {
      const res = await Api.getshXx({
        id: this.params.shid
      });
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      }
      // 控制下一步审核人是否显示
      this.shr_flag = res.xsxyb;

      // 审核人的数据
      let concatList = [];
      if (res.nextRoleList && res.nextRoleList.length > 0) {
        res.nextRoleList.forEach((item, index) => {
          concatList[index] = {
            name: item.userrealname,
            id: item.userid,
            isBtn: 0
          };
        });
      }
      // 控制是否终止流程
      this.isEndShow = res.qzwfdefine.isend;
      this.ywinstanceid = res.qzwfdefine.ywcode;
      this.shrList = this.shrList.concat(concatList);
      if (res.recList.length == 0) {
        this.isShowFile = false;
        this.isShowShyj = false;
      } else {
        this.isShowFile = true;
        this.isShowShyj = true;
      }
    },
    async pushExamine() {
      if (this.shr_flag == "1" && this.spjgId == "1" && !this.shr.mc) {
        this.$toast("请选择下一步审核人");
        return;
      }
      let res = {};
      if (this.params.shlx == "2") {
        res = await Api.savemtsh({
          mtid: this.params.mtid,
          type: this.spjgId,
          shyj: this.bz
        });
      } else {
        res = await Api.workflowAuditing({
          id: this.params.shid,
          type: this.spjgId,
          shyj: this.bz,
          code: this.ywinstanceid,
          userids: this.shr.dm
        });
      }
      if (res.code == "1") {
        this.$toast.success("审核成功！");
        setTimeout(() => {
          if (!!this.params.route) {
            this.$router.push({
              path: this.params.route
            });
          } else {
            this.$router.push({
              path: "/freePass/index"
            });
          }
        }, 1500);
      } else {
        this.$toast(res.Msg);
        setTimeout(() => {
          if (!!this.params.route) {
            this.$router.push({
              path: this.params.route
            });
          } else {
            this.$router.push({
              path: "/freePass/index"
            });
          }
        }, 2000);
      }
    },
    onConfirm1(value) {
      this.spjg = value.text;
      this.spjgId = value.value;
      this.showPicker1 = false;
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    }
  }
};
</script>
<style scoped lang="less">
.stop-item {
  width: 100%;
  display: flex;
  justify-content: center;
}
.bottom-button,
.bottom-button1,
.bottom-button2 {
  font-size: 16px;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  position: absolute;
  bottom: 20px;
  border-radius: 3px;
}
.bottom-button {
  width: calc(~"50% - 30px");
  left: 20px;
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.bottom-button1 {
  width: calc(~"50% - 30px");
  right: 20px;
  background-color: @attendance-background-color-1;
  color: white;
}
.bottom-button2 {
  left: 20px;
  width: calc(~"100% - 40px");
  background-color: @attendance-background-color-1;
  color: white;
}
.center input::placeholder {
  color: @attendance-background-color-2;
  font-weight: 0 !important;
}
/deep/ .van-field__control {
  color: @attendance-color-1 !important;
  font-weight: 600;
}
/deep/ .van-cell {
  font-size: 16px;
}
/deep/.van-field__label {
  width: 120px;
}
/deep/ .van-picker__cancel {
  color: rgba(0, 0, 0, 0);
}
/deep/ .van-picker__confirm {
  color: rgba(0, 0, 0, 0);
}
.xx {
  /deep/ .van-field__body {
    padding-right: 6px;
  }
  /deep/ .van-field__label {
    width: 36px;
  }
}
.upload-line {
  /deep/ .van-field__label {
    width: 75px;
  }
}
/deep/ .van-cell {
  padding: 20px 16px 10px 20px;
}
/deep/ .van-cell:not(:last-child)::after {
  left: 20px;
  right: 20px;
}
/deep/ .van-cell__right-icon {
  margin-left: 3px;
  color: @attendance-background-color-2;
}
/deep/ .van-picker-column {
  position: relative;
}
/deep/ .van-picker-column::before {
  width: 140px !important;
  height: 1px !important;
  background-color: @attendance-background-color-2!important;
  content: "" !important;
  position: absolute !important;
  top: 70px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-bottom: none !important;
  border-top: none !important;
}
/deep/ .van-picker-column::after {
  width: 140px;
  height: 1px;
  background-color: @attendance-background-color-2;
  content: "";
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
/deep/
  .van-ellipsis
  /deep/
  .van-picker-column__item
  /deep/
  .van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}

.stop-item .closeIcon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.stop-item .conIcon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.stop-item .pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.stop-item .pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  border-radius: 5px 5px 0 0;
}
.stop-item .person {
  padding: 57px 15px 15px 15px;
}
.stop-item .person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.stop-item .apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.stop-item .person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
.stop-item
  /deep/.van-popup
  /deep/.van-popup--bottom
  /deep/.van-picker
  /deep/.van-picker-column {
  position: relative;
}
.stop-item
  /deep/.van-ellipsis
  /deep/.van-picker-column__item
  /deep/.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
#reImg {
  background-color: transparent;
  display: flex;
  align-items: center;
}
/* 审核人 */
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/freePass/pass.vue